export const numOnly = (value, maxLen = 15) =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, maxLen);

export const parseTime = (timeStr) => {
  if (!timeStr || typeof timeStr !== "string") return { h: "", m: "" };
  const [h, m] = timeStr.split(":");
  return { h: String(h ?? ""), m: String(m ?? "") };
};

export const clamp = (num, min, max) => {
  if (num === "" || num === null || isNaN(Number(num))) return "";
  return Math.max(min, Math.min(max, Number(num)));
};

export const priorityList = [
  { value: "2", content: "Urgent" },
  { value: "1", content: "High" },
  { value: "0", content: "Normal" },
  { value: "-1", content: "Low" },
];

export const typeOptions = [
  { value: 1, content: "Circle" },
  { value: 2, content: "Polygon" },
  { value: 4, content: "Everywhere" },
  { value: 5, content: "Distance based" },
];

// Fixed 7-day all-day schedule required by API, as a JSON string
export const defaultScheduleStr =
  '[{"enabled":true,"lapses":[{"open":{"hour":0,"minute":0},"close":{"hour":23,"minute":59}}]},{"enabled":true,"lapses":[{"open":{"hour":0,"minute":0},"close":{"hour":23,"minute":59}}]},{"enabled":true,"lapses":[{"open":{"hour":0,"minute":0},"close":{"hour":23,"minute":59}}]},{"enabled":true,"lapses":[{"open":{"hour":0,"minute":0},"close":{"hour":23,"minute":59}}]},{"enabled":true,"lapses":[{"open":{"hour":0,"minute":0},"close":{"hour":23,"minute":59}}]},{"enabled":true,"lapses":[{"open":{"hour":0,"minute":0},"close":{"hour":23,"minute":59}}]},{"enabled":true,"lapses":[{"open":{"hour":0,"minute":0},"close":{"hour":23,"minute":59}}]}]';

export const isMyZoneForZone = (zone) => {
  if (!zone) return true;
  return zone?.businesses?.length
    ? zone?.pivot?.business_id === parseInt(zone?.business_id)
    : true;
};
